import $ from "jquery";

// GIFアニメーションコントロール
// 同じアニメーションを再度再生させるためにVirtualDOMで生成する
let animationTimerId;
export const setAnimation = (container, path) => {
  $(container).append(
    $(`<img id="animationImage" src="${path}?r=${Date.now()}">`)
  );
};

export const resetAnimation = (container) => {
  const imgel = $("#animationImage");
  imgel.remove();
  clearTimeout(animationTimerId);
};
